import { TableColumnMeta } from "ds/components/Table/types";

export enum STACK_WORKSPACES_COLUMN_ID {
  NAME = "NAME",
  LOCK_STATUS = "LOCK_STATUS",
  LOCKED_AT = "LOCKED_AT",
  ROW_ACTIONS = "ROW_ACTIONS",
}

const MAX_CELL_WIDTH = 600;

export const STACK_WORKSPACES_COLUMNS_STORAGE_KEY = "stackWorkspacesColumnsConfig";
export const STACK_WORKSPACES_SORT_STORAGE_KEY = "stackWorkspacesSortConfig";
export const STACK_WORKSPACES_LIMIT_STORAGE_KEY = "stackWorkspacesLimit";
export const STACK_WORKSPACES_LIMIT = 50;
export const STACK_WORKSPACES_PAGINATION_OPTIONS = [10, 25, 50];

export const STACK_WORKSPACES_COLUMN_CONFIG: Record<STACK_WORKSPACES_COLUMN_ID, TableColumnMeta> = {
  [STACK_WORKSPACES_COLUMN_ID.NAME]: {
    id: STACK_WORKSPACES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: false,
    canPin: true,
    canMove: true,
  },
  [STACK_WORKSPACES_COLUMN_ID.LOCK_STATUS]: {
    id: STACK_WORKSPACES_COLUMN_ID.LOCK_STATUS,
    title: "Lock status",
    minWidth: 100,
    defaultWidth: 140,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [STACK_WORKSPACES_COLUMN_ID.LOCKED_AT]: {
    id: STACK_WORKSPACES_COLUMN_ID.LOCKED_AT,
    title: "Locked at",
    minWidth: 120,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [STACK_WORKSPACES_COLUMN_ID.ROW_ACTIONS]: {
    id: STACK_WORKSPACES_COLUMN_ID.ROW_ACTIONS,
    title: "Workspace actions",
    noHeader: true,
    minWidth: 100,
    defaultWidth: 100,
    maxWidth: 100,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const STACK_WORKSPACES_SORT_CONFIG: Record<string, string> = {
  [STACK_WORKSPACES_COLUMN_ID.NAME]: "name",
  [STACK_WORKSPACES_COLUMN_ID.LOCK_STATUS]: "isLocked",
  [STACK_WORKSPACES_COLUMN_ID.LOCKED_AT]: "createdAt",
};
